<template lang="pug">
  .contenedor.pt110
    section.presentacion.letra-morada-oscura
      img(alt="Logo Ellas Libres de Violencias", src="@/assets/LogoEllas.svg")
      prismic-rich-text(:field="data.presentacion")

    main.grid-4-6
      aside.tarjetas-en-columna
        .card.urgencias
          .cabeza
            h2 {{ municipio[0] }}
          .cuerpo
            Urgencias
        
        //- Las modales están en App.vue, por eso el emit
        button(@click="$emit('interruptor', 2)").btn.wth100 Líneas de orientación

        SaberMas.card.pad.fondo-gris-claro

        Citas.card.fondo-rosa.pad

      .derecha.tarjetas-en-columna
        section.violencias.card.fondo-gris-claro
          h2.pad ¿Qué hacer en caso de violencia?
          subMEnuViolencias

        section.emergencia.card
          h1 {{ data.emergencia[0].titulo[0].text }}
            img(src="@/assets/ambulancia.png", width="140", align="middle")
          .contenido.pad.orientacion
            //- ModalEmergencias(:data="contenidoModales[0].data.acciones[0].contenido").orientacion
            p {{contenidoModales[0].data.acciones[0].contenido[1].text}}
            h2 Líneas nacionales
            .espacio
            a(href="tel:123").rosa Llama al 123
            .espacio
            button(@click="policia = true").btn ¿Qué servicios debe prestarme la policía?
            Modal(:visible.sync="policia")
              prismic-rich-text(:field="contenidoModales[0].data.acciones[1].contenido")            
        
        section.preguntas.card.pad.fondo-gris-claro
          router-link(to="/preguntas-frecuentes/0")
            h2 Preguntas frecuentes
          Preguntas
</template>
 
<script>
import Urgencias from '@/components/Urgencias.vue'
import Preguntas from '@/components/PreguntasFrecuentes.vue'
import subMEnuViolencias from '@/components/subMenuViolencias.vue'
import Citas from '@/components/Citas.vue' 
import SaberMas from '@/components/SaberMas.vue' 
import Modal from "@/components/Modal" 
import LineasOrientacion from "@/components/LineasOrientacion" 
import ModalEmergencias from "@/components/ModalEmergencias" 

export default {
  name: 'Inicio',
  props: [
    'urgencias'
  ],
  components: {
      Urgencias,
      Preguntas,
      subMEnuViolencias,
      Citas,
      SaberMas,
      Modal,
      LineasOrientacion,
      ModalEmergencias
  },
  data () {
    return {
        preguntas: null,
        data: [],
        contenidoModales: [],
        policia: false,
        orientacion: false
    };
  },
  methods: {
    getContent () {
      this.$prismic.client.query(
        this.$prismic.Predicates.any('document.type', ['inicio', 'acciones_inicio'])        
      ).then((response) => {
          var inicio = response.results.filter(doc => doc.type == 'inicio')
          this.contenidoModales = response.results.filter(doc => doc.type == 'acciones_inicio')
          this.data = inicio[0].data
      })
    }
  },
  computed: {
    municipio() {
      return this.$store.state.municipio
    }
  },
  created () {
    this.getContent();
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style lang="sass" scoped>
@import "@/sass/globales/_colores"
@import "@/sass/celular/_inicio"
.presentacion
  display: grid
  grid-template-columns: 1fr 2fr 1fr
  grid-gap: 1em
  margin-bottom: 40px
  img 
    max-width: 200px
    position: relative
    top: -80px
    padding-left: 30px
    z-index: 998
.urgencias
  padding: 0
  position: relative
  overflow: hidden
  .cabeza
    display: flex
    align-items: flex-end
    width: 100%
    height: 200px
    color: white
    background: url("../assets/urgencias.png")
    background-size: cover
    background-repeat: no-repeat
    background-position: center bottom
    padding: 14px 40px 18px 36px
    h2 
      margin: 0
  .cuerpo
    padding: 14px 40px 18px 36px
.violencias
  h2 
    background: $morado-ellas
    color: $amarillo
    border-radius: 4px 4px 0 0 
    text-align: center
    margin-top: 0
    padding-top: 26px
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05)
.emergencia
  h1 
    color: $morado-oscuro
    background: $amarillo    
    border-radius: 4px 4px 0 0 
    text-align: center
    margin-top: 0
    padding: 20px 10px 20px
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05)
    img 
      transform: translate(10px, -8px)
  button
    text-align: center
    margin: 30px auto 0
.preguntas
  a
    text-decoration: none
  h2 
    color: $morado-oscuro
    text-align: center
    padding-bottom: 20px
    margin-bottom: 0px
    border-bottom: solid 1px lightgrey
</style>